import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EmailNotificationModel, EmailNotificationPDFModel, GenericDocContainerModel } from '../../../../../../models/aggregates/generic_doc';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class InternalSalesProformaInvoiceService extends BaseApiTemplateService<GenericDocContainerModel> {

  readonly url =
    Core2Config.LOCAL_HOST + Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-sales-proforma-invoices';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = this.url;
    this.endpoint_path = Core2Config.TENANT_URL_PREFIX + Core2Config.DOMAIN_PREFIX + Core2Config.ERP_PREFIX + Core2Config.GENERIC_PREFIX + 'internal-sales-proforma-invoices';
    this.httpClient = http;
  }

  printPdf(guid: string, templateDocId: string, printServiceClassName: string, apiVisa: ApiVisa): Observable<Blob> {
    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-pdf/' + guid,
      {
        headers: new HttpHeaders({
          authorization: apiVisa.jwt_secret,
          responseType: 'blob',
          tenantCode: apiVisa.tenantCode
        }),
        params: new HttpParams()
          .set('templateDocId', templateDocId)
          .set('printServiceClassName', printServiceClassName),
        responseType: 'blob' as 'json'
      }
    );
  }

  public printJasperPdf(
    guid: string,
    printServiceClassName: string,
    printableFormatGuid: string,
    apiVisa: ApiVisa,
    customParam?: string,
  ): Observable<Blob> {
    let params;

    if (customParam) {
      params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid)
      .set('customParam', customParam);
    } else {
      params = new HttpParams()
      .set('printServiceClassName', printServiceClassName)
      .set('printableFormatHdrGuid', printableFormatGuid);
    }

    return this.httpClient.get<Blob>(
      this.apiUrl + '/print-jasper-pdf/' + guid,
      this.getHttpHeaderBlob(apiVisa, params)
    );
  }

  sendEmailNotification(
    guid,
    dtoObject: EmailNotificationModel,
    visa: ApiVisa
  ) {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/email-notification/backoffice-ep/" +
        guid;
    }

    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  sendEmailPDF(
    guid,
    dtoObject: EmailNotificationPDFModel,
    visa: ApiVisa
  ) {
    let url;

    if (this.endpoint_path && visa.api_domain_url) {
      url =
        visa.api_domain_url +
        this.endpoint_path +
        "/send-email-pdf/backoffice-ep/" +
        guid;
    }

    return this.httpClient.post(url, dtoObject, this.getHttpHeader(visa));
  }

  public createTemp(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocContainerModel>>(
      this.apiUrl + '/temp/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
